module.exports = __webpack_public_path__ + "gp.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/gp.svg
// module id = 576
// module chunks = 0